export const verificarElegibilidadeRecadastramento = (vinculo, filters = {}) => {
  if (!vinculo) return false;
  if (
    Array.isArray(filters.admissaoTipos)
    && filters.admissaoTipos.length > 0
    && !filters.admissaoTipos.includes(String(vinculo.admissao_tipo))
  ) return false;
  return !filters.situacaoFolha || vinculo.situacao_folha === filters.situacaoFolha;
};
